<template>
  <lord-icon
    class="lord-icon emat-icon"
    :class="{ close: icon === 'close' }"
    :src="getIcon"
    :trigger="trigger"
    :colors="getColors"
    stoke="100"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: 'ELordIcon',
  props: {
    trigger: {
      type: String,
      default: 'hover',
    },
    icon: {
      type: String,
      default: '',
    },
    primaryColor: {
      type: String,
      default: '#196CAE',
    },
    secondaryColor: {
      type: String,
      default: '#196CAE',
    },
  },
  computed: {
    getColors() {
      let primaryColor = this.primaryColor;
      let secondaryColor = this.secondaryColor;

      return 'primary:' + primaryColor + ',' + 'secondary:' + secondaryColor;
    },

    getIcon: {
      get() {
        let baseUrl = 'https://cdn.lordicon.com/';
        switch (this.icon) {
          case 'questionMark':
            return baseUrl + 'meypkgwe.json';
          case 'close':
            return baseUrl + 'dfyonbvl.json';
          default:
            return '';
        }
      },
      set() {},
    },
  },
  mounted() {
    const element = document.getElementById('lordIconScript');

    if (element) {
      return;
    }

    let lordIconScript = document.createElement('script');
    lordIconScript.id = 'lordIconScript';
    lordIconScript.setAttribute(
      'src',
      'https://cdn.lordicon.com/libs/mssddfmo/lord-icon-2.1.0.js'
    );
    document.head.appendChild(lordIconScript);
  },
};
</script>

<style lang="scss">
.emat-icon {
  cursor: pointer;
}
</style>
